<template>
  <div class="shop-review-sites" v-if="sites">
    <div class="new-card">
      <div class="card-content">
        <p class="field-name has-text-left">
          {{ $t("shop.reviews") }}
        </p>
        <div style="height: 12px" />
        <nav class="level is-mobile" style="margin-bottom: 0">
          <div v-for="s in sites" :key="s" class="level-item has-text-centered">
            <div @click="openReviewSite(s)">
              <p>
                <i class="fa-2x has-text-grey" :class="siteIcon(s)" />
              </p>
              <p class="heading">{{ siteName(s) }}</p>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
    sites() {
      if (!this.business.data.review_sites) return null;
      var sitesString = this.business.data.review_sites;
      return sitesString.split(", "); // used to split on ',' but caused issue with google review link
    },
  },
  mounted() {},
  methods: {
    translateChannel(name) {
      return this.$t(`commerce.${name}`);
    },
    siteName(url) {
      if (url.includes("tripadvisor")) return "TripAdvisor";
      if (url.includes("yelp")) return "Yelp";
      if (url.includes("facebook")) return "Facebook";
      if (url.includes("wongnai")) return "Wongnai";
      if (url.includes("happycow")) return "HappyCow";
      if (url.includes("google")) return "Google";
      if (url.includes("g.co")) return "Google";
      return "TripAdvisor";
    },
    siteIcon(url) {
      var name = this.siteName(url);
      if (name === "TripAdvisor") return "fab fa-tripadvisor";
      if (name === "Yelp") return "fab fa-yelp";
      if (name === "Facebook") return "fab fa-facebook";
      if (name === "Wongnai") return "fab fa-weebly";
      if (name === "Google") return "fab fa-google";
      return "fa fa-star";
    },
    openReviewSite(s) {
      setTimeout(() => window.open(s, "_blank"), 250);
    },
  },
};
</script>

<style scoped>
.field-name {
  padding-bottom: 5px;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}
.new-card {
  overflow-x: hidden;
  background-color: white;
}
/* .card {
  overflow-x: hidden;
} */
.card-content {
  padding: 12px;
}
.fa-2x:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
</style>